import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconNewStore = ({ className, height, width, fill }: IconInterface) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 55 49'
    fill={fill}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M51.4722 0.666626H3.47217V6.66663H51.4722V0.666626ZM54.4722 30.6666V24.6666L51.4722 9.66662H3.47217L0.472168 24.6666V30.6666H3.47217V48.6666H33.4722V30.6666H45.4722V48.6666H51.4722V30.6666H54.4722ZM27.4722 42.6666H9.47217V30.6666H27.4722V42.6666Z'
      fill={fill}
    />
  </svg>
)

export default Icon(IconNewStore)
